<template>
    <q-modal v-model="show_modal_add_plalist" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '90vh'}" @hide="hideModalPlayList('no-playlist')">
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="hideModalPlayList('no-playlist')" icon="fas fa-times" />
                    <q-toolbar-title>
                            {{ $t('new_podcast') }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                     <div class="row gutter-sm q-mb-lg">
                        <div class="col-xs-12 col-sm-12">
                            <q-input v-model="title" :float-label="$t('title')" :error="$v.title.$error" @input="$v.title.$touch" />
                        </div>
                    </div>
                    
                    <q-table
                        :data="playlist"
                        :columns="columns"
                        :loading="loading"
                        row-key="name"
                        :no-data-label="$t('no_data_avaliable')"
                        :no-results-label="$t('no_results_found')"
                        :loading-label="$t('loading_data')"
                        :rows-per-page-label="$t('items_per_page')"
                        :rows-per-page-options="[5,10,50,100]"
                        binary-state-sort
                        >

                        <q-tr slot="header" slot-scope="props" :props="props">
                            <q-th v-for="col in props.cols" :key="col.name" :props="props">
                            {{ $t(col.label) }}
                            </q-th>
                        </q-tr>

                        <q-tr slot="body" slot-scope="props" :props="props">
                            <q-td auto-width key="id" :props="props">
                                {{ props.row.id }}
                            </q-td>

                            <q-td key="title" :props="props">
                                {{ props.row.title }}
                            </q-td>

                            <q-td key="origin_playlist" :props="props">
                                {{ props.row.origin_playlist }}
                            </q-td>
                        </q-tr>
                    </q-table>

                    <div class="row gutter-sm justify-end q-mt-lg">
                        <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                            <q-btn color="tertiary" class="full-width" :label="$t('back')" icon="fas fa-chevron-left" @click="hideModalPlayList('no-playlist')" />
                        </div>

                        <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                            <q-btn color="secondary" class="full-width" :label="$t('save')" icon="far fa-save" @click="saveData()" />
                        </div>
                    </div>
                </div>
            </q-modal-layout>
        </q-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import Uploader from 'components/Uploader'
export default {
    props: ['show', 'podcast'],

    data(){
        return {
            id: 0,
            title: '',
            description: '',
            audios: [],
            tag: [],
            image_url: '',
            columns: [
                {
                    name: 'id',
                    required: true,
                    label: '#',
                    align: 'left',
                    field: 'id',
                    sortable: false,
                },
                {
                    name: 'title',
                    required: true,
                    label: 'title',
                    align: 'left',
                    field: 'title',
                    sortable: false,
                },
                {
                    name: 'origin_playlist',
                    required: true,
                    label: 'playlists',
                    align: 'left',
                    field: 'origin_playlist',
                    sortable: false,
                },
            ],
            loading: false
        }
    },

    components: {
        'uploader': Uploader,
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            all_tags: 'site_lists/tags',
            playlist: 'podcasts/playlist',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        show_modal_add_plalist: {
            get() {
                return this.show
            },
            set(val) {
                this.title = '',
                this.description = '',
                this.tag = [],
                this.image_url = '',
                this.$v.$reset()

                this.$emit('hideModalPlayList', 'no-comment')
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '50vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },
    },

    methods: {
        imageUploaded(url) {
            this.image_url = url
        },

        saveData(){
            this.$v.$touch()
            if (!this.$v.$error) {
                this.$q.loading.show()
                let new_audios = this.playlist.map(e => e.id)
                let fd = {
                    'title': this.title,
                    'audios': [...new_audios, ...this.audios]
                }

                if (this.id != 0) {
                    this.$axios.put(`/etraining_podcast/playlist_user/${this.id}/`, fd, this.getHeader)
                    .then(response => {
                        this.$store.dispatch('podcasts/SET_PLAYLIST', [[]])
                        this.hideModalPlayList('add-playlist')
                        this.$q.notify({
                            message: this.$t('playlist_save_success'),
                            type: 'positive',
                            icon: 'far fa-save'
                        })
                    })
                    .catch(e => {
                        console.log(e)

                        this.$q.notify({
                            message: this.$t('unexpected_error_try_again_later'),
                            type: 'negative',
                            icon: 'fas fa-ban'
                        })
                    })
                    .finally(() => {
                        this.$q.loading.hide()
                    })
                }
                else{
                    this.$axios.post(`etraining_podcast/playlist_user/`, fd, this.getHeader)
                    .then(response => {
                        this.$store.dispatch('podcasts/SET_PLAYLIST', [[]])
                        this.hideModalPlayList('add-playlist')
                        this.$q.notify({
                            message: this.$t('playlist_save_success'),
                            type: 'positive',
                            icon: 'far fa-save'
                        })
                    })
                    .catch(e => {
                        console.log(e)
                        this.$q.notify({
                            message: this.$t('unexpected_error_try_again_later'),
                            type: 'negative',
                            icon: 'fas fa-ban'
                        })
                        
                    })
                    .finally(() => {
                        this.$q.loading.hide()
                    })
                }

            }
            else{
                this.$q.notify({
                    message: this.$t('make_sure_that_all_fields_are_filled_in'),
                    type: 'negative',
                    icon: 'fas fa-exclamation-triangle',
                    position: 'top'
                })
            }
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        },

        hideModalPlayList(type) {
            this.title = '',
            this.description = '',
            this.tag = [],
            this.image_url = '',
            this.$v.$reset()

            this.$emit('hideModalPlayList', type)
        },
    },

    watch: {
        show: function(e) {
            if(e){
                if(this.podcast) {
                    this.id = this.podcast.id 
                    this.title = this.podcast.title
                    this.description = this.podcast.description
                    this.tag = this.podcast.tags
                    this.image_url = ''
                    this.audios = this.podcast.podcast_playlist_audio.map(e => e.id)
                }
            }
           
        },
    },

    validations() {
        return {
            title: { required }
        }
    }
}
</script>

<style>

</style>